import { ElementRef } from '@angular/core';
import { KeyDirections } from '../../shared/key-directions.enum';
import { PageNames } from '../../shared/page-names.enum';
import { NavigationState } from '../../model/navigation/navigation-state';
var NavigationService = /** @class */ (function () {
    function NavigationService() {
        this.state = new NavigationState();
        this.previousState = new NavigationState();
    }
    NavigationService.prototype.navigate = function (keyCode) {
        if (this.getActiveNavigationItem().canNavigateToDirection(keyCode)) {
            if (keyCode !== KeyDirections.ESCAPE && (this.state.activeX === undefined || this.state.activeY === undefined)) {
                this.resetNavigation();
                return;
            }
            switch (keyCode) {
                case KeyDirections.ARROW_LEFT:
                    this.navigateLeft();
                    break;
                case KeyDirections.ARROW_UP:
                    this.navigateUp();
                    break;
                case KeyDirections.ARROW_RIGHT:
                    this.navigateRight();
                    break;
                case KeyDirections.ARROW_DOWN:
                    this.navigateDown();
                    break;
                case KeyDirections.ENTER:
                    this.clickCurrentActivatedElement();
                    break;
                case KeyDirections.ESCAPE:
                    this.navigateBack();
                    break;
            }
            this.skipNotSelectables(keyCode);
        }
    };
    NavigationService.prototype.skipNotSelectables = function (keyCode) {
        if (this.state.navItemSource[this.state.currentPageActiveComponent]
            && this.state.navItemSource[this.state.currentPageActiveComponent].length > 0
            && !this.getActiveNavigationItem().isSelectable()) {
            this.navigate(keyCode);
        }
    };
    NavigationService.prototype.navigateBack = function () {
        if (this.getActiveNavigationItem() && this.getActiveNavigationItem().active) {
            this.getActiveNavigationItem().onBack();
        }
    };
    NavigationService.prototype.clickCurrentActivatedElement = function () {
        if (this.getActiveNavigationItem() && this.getActiveNavigationItem().active) {
            this.getActiveNavigationItem().onEnter();
        }
    };
    NavigationService.prototype.navigateDown = function () {
        if (this.state.activeY >= (this.state.navItemSource[this.state.currentPageActiveComponent].length - 1)) {
            this.goToNextDetailPageSection();
        }
        else {
            this.setActiveNavigationItemActive(false);
            this.state.activeY++;
            if (!this.getActiveNavigationItem()) {
                this.state.activeX = 0;
            }
            this.setActiveNavigationItemActive(true);
            if (this.isCurrentPageHomepage()) {
                this.scrollToInHomepage();
            }
        }
    };
    NavigationService.prototype.navigateRight = function () {
        if (this.state.infiniteScrolling && this.state.activeX === (this.getActiveNavigationRow().length - 1)) {
            this.setActiveNavigationItemActive(false);
            this.state.activeX = -1;
        }
        if ((this.state.activeX + 1) < this.getActiveNavigationRow().length
            && this.getActiveNavigationRow()[this.state.activeX + 1]
            && this.getActiveNavigationRow()[this.state.activeX + 1].canNavigateToDirection(KeyDirections.ARROW_RIGHT)) {
            this.setActiveNavigationItemActive(false);
            this.state.activeX++;
            this.setActiveNavigationItemActive(true);
        }
    };
    NavigationService.prototype.navigateUp = function () {
        if (this.state.activeY === 0) {
            this.goToPreviousDetailPageSection();
        }
        else {
            this.setActiveNavigationItemActive(false);
            this.state.activeY--;
            if (!this.getActiveNavigationItem()) {
                this.state.activeX = 0;
            }
            this.setActiveNavigationItemActive(true);
            if (this.isCurrentPageHomepage()) {
                this.scrollToInHomepage();
            }
        }
    };
    NavigationService.prototype.navigateLeft = function () {
        if (this.state.infiniteScrolling && this.state.activeX === 0) {
            this.setActiveNavigationItemActive(false);
            this.state.activeX = this.getActiveNavigationRow().slice(-1).pop().x + 1;
        }
        if (this.state.activeX > 0
            && this.getActiveNavigationRow()[this.state.activeX - 1].canNavigateToDirection(KeyDirections.ARROW_LEFT)) {
            this.setActiveNavigationItemActive(false);
            this.state.activeX--;
            this.setActiveNavigationItemActive(true);
        }
    };
    NavigationService.prototype.resetPage = function () {
        this.setActiveNavigationItemActive(false);
        var firstComponentName = this.state.currentPageComponents[0];
        this.goToPageSection(firstComponentName);
        this.resetNavigation();
    };
    NavigationService.prototype.getActiveNavigationRow = function () {
        return this.state.navItemSource[this.state.currentPageActiveComponent][this.state.activeY];
    };
    NavigationService.prototype.getActiveNavigationItem = function () {
        return this.state.navItemSource[this.state.currentPageActiveComponent][this.state.activeY][this.state.activeX];
    };
    NavigationService.prototype.setActiveNavigationItemActive = function (active) {
        if (this.getActiveNavigationItem()) {
            this.getActiveNavigationItem().activate(active);
        }
    };
    NavigationService.prototype.goToNextDetailPageSection = function () {
        if (this.state.currentPageActiveComponent) {
            var goToComponentName = this.getGoToComponentName();
            if (goToComponentName) {
                this.goToPageSection(goToComponentName);
                this.resetNavigation();
            }
        }
    };
    NavigationService.prototype.goToPreviousDetailPageSection = function () {
        var _this = this;
        if (this.state.currentPageActiveComponent) {
            var previousName_1;
            var goToComponentName_1;
            this.state.currentPageComponents.forEach(function (currentPageComponent) {
                if (currentPageComponent === _this.state.currentPageActiveComponent) {
                    goToComponentName_1 = previousName_1;
                }
                previousName_1 = currentPageComponent;
            });
            if (goToComponentName_1) {
                this.goToPageSection(goToComponentName_1);
                this.resetNavigation(true);
            }
        }
    };
    NavigationService.prototype.goToPageSection = function (component) {
        this.state.navItemSource[this.state.currentPageActiveComponent][this.state.activeY][this.state.activeX].activate(false);
        this.state.currentPageActiveComponent = component + '';
        this.scrollTo(component);
        this.checkIfSectionIsLast();
    };
    NavigationService.prototype.checkIfSectionIsLast = function () {
        if (this.state.currentPageActiveComponent) {
            var goToComponentName = this.getGoToComponentName();
            if (this.state.navItemSource[PageNames.ARROW_DIRECTION]) {
                this.state.navItemSource[PageNames.ARROW_DIRECTION][0][0].pointsDown = goToComponentName !== PageNames.ARROW_DIRECTION;
            }
        }
    };
    NavigationService.prototype.getGoToComponentName = function () {
        var _this = this;
        var goToComponentName;
        var goToNext = false;
        this.state.currentPageComponents.forEach(function (currentPageComponent) {
            if (goToNext) {
                goToComponentName = currentPageComponent;
            }
            goToNext = currentPageComponent === _this.state.currentPageActiveComponent;
        });
        return goToComponentName;
    };
    NavigationService.prototype.resetNavigation = function (navigatingBack) {
        var navItemSourceElement = this.state.navItemSource[this.state.currentPageActiveComponent];
        this.state.activeY = navItemSourceElement && navigatingBack ? navItemSourceElement.length - 1 : 0;
        this.state.activeX = 0;
        this.activateFirstUnsubscribedItem(navItemSourceElement);
    };
    NavigationService.prototype.activateFirstUnsubscribedItem = function (navItemSourceElement) {
        if (this.state.navItemSource && navItemSourceElement) {
            var navSourceItem = navItemSourceElement[this.state.activeY][this.state.activeX];
            if (navSourceItem.isSubscribed() && navItemSourceElement[this.state.activeY].length > 1) {
                this.activateNextXItem();
            }
            else {
                this.state.navItemSource[this.state.currentPageActiveComponent][this.state.activeY][this.state.activeX].activate(true);
            }
        }
    };
    NavigationService.prototype.activateNextXItem = function () {
        this.state.navItemSource[this.state.currentPageActiveComponent][this.state.activeY][this.state.activeX = this.state.activeX + 1].activate(true);
    };
    NavigationService.prototype.registerNavigation = function (item, currentPageComponent) {
        if (!this.state.navItemSource[currentPageComponent]) {
            this.state.navItemSource[currentPageComponent] = Array();
            this.state.currentPageComponents.push(currentPageComponent);
        }
        if (this.state.navItemSource[currentPageComponent][item.y] === undefined) {
            this.state.navItemSource[currentPageComponent][item.y] = Array();
        }
        this.state.navItemSource[currentPageComponent][item.y][item.x] = item;
    };
    NavigationService.prototype.registerPageElement = function (pageElement) {
        this.state.currentPageElement = pageElement;
    };
    NavigationService.prototype.divideInRowsByElementPosition = function (componentName, navigationItems) {
        var _this = this;
        var currentRowIndex = navigationItems[0].y;
        var yValues = [];
        var newRows = [];
        var navItemSource = this.state.navItemSource[componentName][currentRowIndex];
        navItemSource.forEach(function (navigationItem) {
            var y = Math.round(navigationItem.gridElement.nativeElement.getBoundingClientRect()['y'] / 10) * 10;
            if (!yValues.includes(y)) {
                yValues.push(y);
                newRows[currentRowIndex + yValues.findIndex(function (yValue) { return y === yValue; })] = Array();
            }
            newRows[currentRowIndex + yValues.findIndex(function (yValue) { return y === yValue; })].push(navigationItem);
        });
        newRows.forEach(function (newRow, index) {
            _this.state.navItemSource[componentName][index] = newRow;
        });
    };
    NavigationService.prototype.clearNavigation = function () {
        this.state = new NavigationState();
    };
    NavigationService.prototype.setCurrentPageComponent = function (currentPageComponent) {
        this.state.currentPageActiveComponent = currentPageComponent;
    };
    NavigationService.prototype.restorePreviousState = function () {
        this.state = this.previousState;
        this.clearPreviousState();
    };
    NavigationService.prototype.setPreviousState = function () {
        this.previousState = this.state;
    };
    NavigationService.prototype.clearPreviousState = function () {
        this.previousState = new NavigationState();
    };
    NavigationService.prototype.setInfiniteScrolling = function (infiniteScrolling) {
        this.state.infiniteScrolling = infiniteScrolling;
    };
    NavigationService.prototype.scrollTo = function (component) {
        var nextPageIndex = this.state.currentPageComponents.findIndex(function (componentName) { return componentName === component; });
        var nextPageIndexCount = this.state.currentPageComponents.length;
        if (nextPageIndex < nextPageIndexCount - 1) {
            this.state.vhValue = -95;
            this.state.vhValue = this.state.vhValue * nextPageIndex;
            if (this.state.currentPageElement) {
                this.state.currentPageElement.nativeElement.style.transform = 'translate3d(0, ' + this.state.vhValue + 'vh , 0)';
            }
        }
    };
    NavigationService.prototype.scrollToInHomepage = function () {
        if (this.state.activeY > 1) {
            this.state.vhValue = -45;
            this.state.vhValue = this.state.vhValue * (this.state.navItemSource[PageNames.HOMEPAGE].length - this.state.activeY);
        }
        else {
            this.state.vhValue = 0;
        }
        if (this.state.currentPageElement) {
            this.state.currentPageElement.nativeElement.style.transform = 'translate3d(0, ' + this.state.vhValue + 'vh , 0)';
        }
    };
    NavigationService.prototype.isCurrentPageHomepage = function () {
        return this.state.currentPageActiveComponent === PageNames.HOMEPAGE;
    };
    return NavigationService;
}());
export { NavigationService };
